import { FunctionComponent } from "react"
import styled from "styled-components"
import * as React from "react"
import { ArrowBack } from "../../atoms/icons/ArrowBack"
import { ArrowRight } from "../../atoms/icons/ArrowRight"
import { useNavigate } from "react-router-dom"
import Subtitle from "../../atoms/typography/Subtitle"
import Body from "../../atoms/typography/Body"
import LargeButton from "../../atoms/buttons/LargeButton"
import { theme } from "../../theme"
import { Col, Hidden, Row, Visible } from "react-grid-system"
import H1 from "../../atoms/typography/H1"
import SmallButton from "../../atoms/buttons/SmallButton"
import { HorizontalSpacer } from "../../atoms/spacers"
import PrimaryButton from "../../atoms/buttons/PrimaryButton"
import { CheckoutType } from "../../../graphql/mutations/createUnpaidOrder"
import { CartStructure } from "../../interfaces/SaleorTypes"

interface CheckoutJourneyIntroProps {
  onCheckoutTypeClick: (type: CheckoutType) => void
  cart: CartStructure[]
}

const IntroContainer = styled.div``

const ContentContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  margin-top: 3em;
  row-gap: 1em;
`

const CheckoutJourneyIntroSection: FunctionComponent<CheckoutJourneyIntroProps> = ({
  onCheckoutTypeClick,
  cart,
  ...props
}) => {
  const onButtonClick = (type: CheckoutType) => {
    onCheckoutTypeClick(type)
  }
  const navigate = useNavigate()

  const terminalsInCart = cart.filter((cartItem) => cartItem.product.category.name === "Terminals")
  const hasTerminalInCart = terminalsInCart.length > 0

  return (
    <IntroContainer>
      <Row justify="between" align="center" style={{ padding: "0 15px" }}>
        <Col lg={6} md={12} xs={12}>
          <H1>Checkout</H1>
          <Visible xs md>
            <HorizontalSpacer spacing={2} />
          </Visible>
        </Col>

        <SmallButton title="Back to store" leftIcon={<ArrowBack />} onClick={() => navigate("/store")} />
      </Row>
      <HorizontalSpacer spacing={2} />{" "}
      <ContentContainer>
        <Subtitle>Direct purchase</Subtitle>
        <Body>
          You can buy your Satcube terminals and accessories directly online. The estimated delivery time is 30 days
          after order confirmation.
        </Body>
        <div>
          <Hidden xs>
            <LargeButton
              title="Make a direct purchase"
              icon={<ArrowRight color={theme.colors.greyDark} />}
              onClick={() => onButtonClick("direct")}
            />
          </Hidden>
          <Visible xs>
            <PrimaryButton title="Direct purchase" iconRight={<ArrowRight />} onClick={() => onButtonClick("direct")} />
          </Visible>
        </div>
      </ContentContainer>
      {hasTerminalInCart && (
        <div>
          <ContentContainer>
            <Subtitle>Leasing</Subtitle>
            <Body>
              Satcube offers leasing for 24 or 36 months for all our terminals. Leasing price is subject to Credit
              Control and current interest rates. Full warranty is included during the whole leasing period.
            </Body>
            <div>
              <Hidden xs>
                <LargeButton
                  title="Apply for leasing"
                  icon={<ArrowRight color={theme.colors.greyDark} />}
                  onClick={() => onButtonClick("leasing")}
                />
              </Hidden>
              <Visible xs>
                <PrimaryButton
                  title="Apply for leasing"
                  iconRight={<ArrowRight />}
                  onClick={() => onButtonClick("leasing")}
                />
              </Visible>
            </div>
          </ContentContainer>
        </div>
      )}
    </IntroContainer>
  )
}

export default CheckoutJourneyIntroSection
